import { useCallback } from 'react';
import type { MemberEntityScope } from '../types';

export const useGetMemberBreadcrumbEntityName = () =>
  useCallback(({ entityScope }: { entityScope: MemberEntityScope }) => {
    switch (entityScope) {
      case 'communities':
        return 'Joined communities';
      case 'organizations':
        return 'Joined organizations';
      case 'programs':
        return 'Joined programs';
    }
  }, []);
